class DropdownRadioList {

    constructor(el) {
        this.el = el;
        this.toggle = el.querySelector('.dropdown-toggle');
        this.labels = el.querySelectorAll('li label');
        this.radios = el.querySelectorAll('input[type="radio"]');
        this.prevIndex = -1;
        if(this.radios != null) {
            this.radios.forEach((r,i) => {
                if(r.checked) this.update(i,r);
                r.addEventListener('click', () => {
                    this.update(i,r);
                });
            });
        }
    }

    update(i,r) {
        this.toggle.innerHTML = this.labels[i].innerHTML;
        r.setAttribute('checked','checked');
        if(this.prevIndex >= 0 && this.prevIndex != i) {
            this.radios[this.prevIndex].removeAttribute('checked');
            this.prevIndex = i;
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new DropdownRadioList(node);
        }
    });
}